import { render, staticRenderFns } from "./BotoxConfigurazioneDiagnosiEditModalComponent.vue?vue&type=template&id=22370e1f&scoped=true"
import script from "./BotoxConfigurazioneDiagnosiEditModalComponent.vue?vue&type=script&lang=js"
export * from "./BotoxConfigurazioneDiagnosiEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22370e1f",
  null
  
)

export default component.exports